import LdapSettings from './LdapSettings';

export default LdapSettings;
